import { queryOptions } from '@tanstack/react-query';

import { fetchScreenRules } from './api/rules.api';

export const rulesKeys = {
  all: ['rules'] as const,
};

export const screenRulesQueryOptions = () =>
  queryOptions({
    queryKey: rulesKeys.all,
    queryFn: ({ signal }) => fetchScreenRules(signal),
    staleTime: Infinity,
    gcTime: Infinity,
  });
